/**
 * Un interrupteur entre deux affichages d'une même page (11/10/2026) : la vue actuelle, par défaut, et une vue
 * À L'ESSAI à côté d'elle, sans rien remplacer. Sur le bandeau en dégradé des pages de résultats, il passe en
 * blanc (surFondColore).
 */
const InterrupteurVue = ({ options, valeur, onChange, etiquette, surFondColore = false }) => (
  <div
    role="group"
    aria-label={etiquette}
    className={`inline-flex flex-wrap gap-1 rounded-xl p-1 ${surFondColore ? 'bg-white/20 backdrop-blur' : 'bg-white border border-slate-200 shadow-sm'}`}
  >
    {options.map((option) => {
      const actif = option.cle === valeur;
      const style = surFondColore
        ? (actif ? 'bg-white text-blue-700 shadow' : 'text-white hover:bg-white/15')
        : (actif ? 'bg-gradient-to-br from-blue-500 to-cyan-500 text-white shadow-md shadow-blue-500/30' : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50');
      return (
        <button
          key={option.cle}
          type="button"
          aria-pressed={actif}
          onClick={() => onChange(option.cle)}
          className={`px-3 py-1.5 rounded-lg text-[13px] font-semibold transition-colors duration-200 ${style}`}
        >
          {option.libelle}
          {option.essai ? <span className={`ml-1.5 text-[10px] uppercase tracking-wide ${actif && !surFondColore ? 'text-white/80' : 'opacity-70'}`}>essai</span> : null}
        </button>
      );
    })}
  </div>
);

export default InterrupteurVue;
